import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 切换语言 ")

import { computed, unref } from 'vue'
import { ElDropdown, ElDropdownMenu, ElDropdownItem } from 'element-plus'

/* Stores */
import { useLocaleStore } from '../../store/locale';

/* Hooks */
import { useLocaleChange } from '../../hooks/useLocales';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const localeStore = useLocaleStore();

const langMap = computed(() => localeStore.getLocaleMap)

const currentLang = computed(() => localeStore.getCurrentLocale)

const setLang = (lang: LocaleType) => {

    if (lang === unref(currentLang).lang) return

    window.location.reload()

    localeStore.setCurrentLocale({
        lang
    })

    const { changeLocale } = useLocaleChange()

    changeLocale(lang)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElDropdown), {
    trigger: "click",
    onCommand: setLang
  }, {
    dropdown: _withCtx(() => [
      _createVNode(_unref(ElDropdownMenu), null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(langMap), (item) => {
            return (_openBlock(), _createBlock(_unref(ElDropdownItem), {
              key: item.lang,
              command: item.lang
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.name), 1)
              ]),
              _: 2
            }, 1032, ["command"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})